import images from './images';


function mixedCards(cardsNumber) {
    var mixCards = images;
    for (let i = 0; i < mixCards.length; i++) {
        let temp = mixCards[i];
        let j = Math.floor(Math.random() * mixCards.length);
        mixCards[i] = mixCards[j];
        mixCards[j] = temp;
    }
    mixCards = mixCards.slice(0, cardsNumber);
    mixCards = mixCards.concat(mixCards);
    for (let i = 0; i < mixCards.length; i++) {
        let temp = mixCards[i];
        let j = Math.floor(Math.random() * mixCards.length);
        mixCards[i] = mixCards[j];
        mixCards[j] = temp;
    }

    let deck = [];
    mixCards.map((item, i) => {
        deck.push({ img: item.img, matched: false, id: i });
        return deck;
    });
    return deck;
};

export { mixedCards }